import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageSessionService } from '../../storage/services/storage.session.service';
import { HttpService } from '../../service/services/http.service';
import { HttpClient } from '@angular/common/http';
import { AnalyticsCoreURLService } from '../../../reporting/analytics-core/services/analytics-core.url.service';

@Injectable()
export class AuthService extends HttpService {
	constructor(
		http: HttpClient,
		storageSessionService: StorageSessionService,
		router: Router,
		private analyticsCoreURLService: AnalyticsCoreURLService
	) {
		super(http, storageSessionService, router);
	}

	checkSession(serviceURL: string) {
		return this.get(serviceURL).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	verifySSOAccessToken(token: string) {
		const reqBody = <any>{};
		reqBody['user_key'] = token;
		reqBody['domain'] = this.analyticsCoreURLService.domainName;
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/api_login_with_key', reqBody).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}

	verifyChangePasswordDetails(details: any) {
		const reqBody = {
			domain: this.analyticsCoreURLService.domainName,
			passkey: details.passkey,
			userid: details.userid
		};
		return this.post(this.analyticsCoreURLService.serviceURL + '/analytics_module/validate_userid', reqBody).pipe(
			map((res) => res),
			catchError((error) => this.handleError(error))
		);
	}
}
